import {
    StyleSheet
} from "react-native";
import type {
    SidebarMeasures
} from "../../type";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        position: "relative",
        minWidth: 0
    }
});

export const useStyles = ({
    measures,
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
    measures: SidebarMeasures;
}) => {
    return {
        container: {
            paddingHorizontal: measures.padding,
            paddingVertical: spaces.spacingSm
        }
    };
};
export default stylesheet;
